/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlResolutionRequestAttestation } from './ControlResolutionRequestAttestation';
import {
    ControlResolutionRequestAttestationFromJSON,
    ControlResolutionRequestAttestationFromJSONTyped,
    ControlResolutionRequestAttestationToJSON,
} from './ControlResolutionRequestAttestation';
import type { ControlResolutionRequestReason } from './ControlResolutionRequestReason';
import {
    ControlResolutionRequestReasonFromJSON,
    ControlResolutionRequestReasonFromJSONTyped,
    ControlResolutionRequestReasonToJSON,
} from './ControlResolutionRequestReason';
import type { ControlResolutionRequestStatus } from './ControlResolutionRequestStatus';
import {
    ControlResolutionRequestStatusFromJSON,
    ControlResolutionRequestStatusFromJSONTyped,
    ControlResolutionRequestStatusToJSON,
} from './ControlResolutionRequestStatus';
import type { ControlResolutionRequestUser } from './ControlResolutionRequestUser';
import {
    ControlResolutionRequestUserFromJSON,
    ControlResolutionRequestUserFromJSONTyped,
    ControlResolutionRequestUserToJSON,
} from './ControlResolutionRequestUser';

/**
 * 
 * @export
 * @interface ControlResolutionRequestResponseV1
 */
export interface ControlResolutionRequestResponseV1 {
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    request_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    entity_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    org_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlResolutionRequestResponseV1
     */
    assets?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    datapoint: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    name?: string;
    /**
     * 
     * @type {ControlResolutionRequestReason}
     * @memberof ControlResolutionRequestResponseV1
     */
    reason?: ControlResolutionRequestReason;
    /**
     * 
     * @type {ControlResolutionRequestStatus}
     * @memberof ControlResolutionRequestResponseV1
     */
    status: ControlResolutionRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    updated: string;
    /**
     * 
     * @type {ControlResolutionRequestUser}
     * @memberof ControlResolutionRequestResponseV1
     */
    user?: ControlResolutionRequestUser;
    /**
     * 
     * @type {Array<ControlResolutionRequestAttestation>}
     * @memberof ControlResolutionRequestResponseV1
     */
    attestations?: Array<ControlResolutionRequestAttestation>;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponseV1
     */
    notes?: string;
}

/**
 * Check if a given object implements the ControlResolutionRequestResponseV1 interface.
 */
export function instanceOfControlResolutionRequestResponseV1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_id" in value;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "entity_name" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "datapoint" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function ControlResolutionRequestResponseV1FromJSON(json: any): ControlResolutionRequestResponseV1 {
    return ControlResolutionRequestResponseV1FromJSONTyped(json, false);
}

export function ControlResolutionRequestResponseV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolutionRequestResponseV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'entity_id': json['entity_id'],
        'entity_name': json['entity_name'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'assets': !exists(json, 'assets') ? undefined : json['assets'],
        'datapoint': json['datapoint'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'reason': !exists(json, 'reason') ? undefined : ControlResolutionRequestReasonFromJSON(json['reason']),
        'status': ControlResolutionRequestStatusFromJSON(json['status']),
        'created': json['created'],
        'updated': json['updated'],
        'user': !exists(json, 'user') ? undefined : ControlResolutionRequestUserFromJSON(json['user']),
        'attestations': !exists(json, 'attestations') ? undefined : ((json['attestations'] as Array<any>).map(ControlResolutionRequestAttestationFromJSON)),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function ControlResolutionRequestResponseV1ToJSON(value?: ControlResolutionRequestResponseV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.request_id,
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'assets': value.assets,
        'datapoint': value.datapoint,
        'name': value.name,
        'reason': ControlResolutionRequestReasonToJSON(value.reason),
        'status': ControlResolutionRequestStatusToJSON(value.status),
        'created': value.created,
        'updated': value.updated,
        'user': ControlResolutionRequestUserToJSON(value.user),
        'attestations': value.attestations === undefined ? undefined : ((value.attestations as Array<any>).map(ControlResolutionRequestAttestationToJSON)),
        'notes': value.notes,
    };
}

